import React from 'react';
import { Button, Tooltip } from 'antd';
import LocalizedDate from '../../Localization/LocalizedDate';
import api from '../../../Api';
import { connectToRequests } from '../../Requests/containers/RequestsDataStore';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';

export function CancelRequestLabel({ submittedDate }) {
	return (
		<React.Fragment>
			Cancel Pending Request
			<br />
			<span style={{ fontSize: 'smaller' }}>
				(made on <LocalizedDate dateString={submittedDate} />)
			</span>
		</React.Fragment>
	);
}

export class CancelRequest extends React.Component {
	render() {
		if (this.props.isMobile()) {
			return this.renderButton();
		}
		return (
			<Tooltip title={this.getTooltip()} placement="left">
				{this.renderButton()}
			</Tooltip>
		);
	}

	renderButton = () => (
		<Button shape="circle" onClick={this.cancelRequest}>
			<div className="relative">
				<div className="icon-hand-paper-o request-hand" />
				<div
					className="icon-declined cancel-request"
					style={{
						fontSize: '9px',
						position: 'absolute',
						bottom: '5px',
						right: '10px',
						color: '#fc601f',
					}}
				/>
			</div>
		</Button>
	);

	getTooltip() {
		const { submittedDate } = this.props;
		return <CancelRequestLabel submittedDate={submittedDate} />;
	}

	cancelRequest = () => {
		const { sku } = this.props;

		if (!window.confirm('Cancel this request?')) {
			return;
		}

		api.post(`/api/me/galleys/${sku}/cancel`).then(res => {
			this.props.requestsDataStore.refresh();
		});
	};
}

export default connectToRequests(withIsMobile(CancelRequest));
